<template>
  <div>
    <a-row v-for="item in infos" :key="item.label" :gutter="[25, 14]">
      <a-col :span="item.labelSpan || 4">
        <span class="label">{{ item.label }}:</span>
      </a-col>
      <a-col :span="item.valueSpan || 20">
        <span v-if="item.isVHtml" v-html="item.value"></span>
        <div v-else-if="item.isTable">
          <a-table bordered :data-source="item.value" :columns="item.columns" :pagination="false"
            :scroll="{ x: 'calc(700px + 50%)', y: 450 }">
          </a-table>
        </div>
        <div v-else-if="item.isSelect">
          <a-select style="width: 100%" v-model="item.value" @change="handleChange($event, item)" v-if="isDetail">
            <a-select-option v-for="items in item.selectList" :value="items.value" :key="items.value">
              {{ items.label }}
            </a-select-option>
          </a-select>
          <span v-else>{{ item.value }}</span>
        </div>
        <div v-else-if="item.isFile">
          <div v-for="ele in item.value" :key="ele.fileId" @click="downClick(ele)" style="cursor: pointer;">
            {{ele.fileName}}
          </div>
        </div>
        <span v-else>{{ item.value }}</span>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { downFile } from '@/api/home'
export default {
  props: {
    infos: Array,
  },
  data () {
    return {
      isDetail: false,
    }
  },
  mounted () {
  },
  methods: {
    handleChange (e) {
      this.$emit('selectChange', e)
    },
    async downClick (item) {
      const data = await downFile(item.fileId)
      const blob = new Blob([data])
      const elink = document.createElement('a')
      elink.download = item.fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    },
    // 下载文件
    downloadFile (name, url) {
      const a = document.createElement('a');
      a.setAttribute('download', name);
      a.setAttribute('href', url);
      a.click();
      document.body.removeChild(a)
    },
  },
}
</script>
